<template>
  <div class="body" id="bj">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div >
        <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">会员中心</p>
            <router-link :to="`/index`" class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>会员中心
            </router-link>
            <div class="pub_xian"></div>
        </div>
        <div class="h-20"></div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">会员中心</p>
            </div>
            <div class="w-products rihgt Member-right">
              <div class="member-label DeviceInfos" style="display: flex;"  >
                  <el-upload slot="append" :show-file-list="false"  action="http://spoa/api.php/Upload/flie" :data="datain" :before-upload="handleUploadBefore" :on-success="handleUploadSuccess">
                    <el-button  size="small" type="warning" >点击上传</el-button>
                  </el-upload>

                  <el-button  size="small" type="warning" style="margin-left: 20px;" @click="xzadd(info.file)">模板下载</el-button>



              </div>
                <p style="font-size: 12px; color: #e6a23c">文件大小不可大于5M且必须按照模版格式进行上传</p>
              <el-table
                  v-loading="loading"
                  ref="multipleTable"
                  :data="list"
                  style="width: 100%"
                  >
                  <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                  <el-table-column label="提交时间 " width="200">
                    <template slot-scope="scope">{{ scope.row.create_time }}</template>
                  </el-table-column>
                  <el-table-column label="提交人 " width="120">
                    <template slot-scope="scope">{{ scope.row.username }}</template>
                  </el-table-column>
                  <el-table-column label="采购需求表格名称 " show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                  </el-table-column>

                 <!-- <el-table-column label="状态 " width="120">
                    <template slot-scope="scope">{{ scope.row.status_text }}</template>
                  </el-table-column> -->
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="xzadd(scope.row.title)">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>



              <!-- <input type="file" name="file" ref="file" id="file" v-on:change="upload" style="visibility: hidden;" />
                      <label for="file" class="fileBtn">上传</label> -->



              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>
          </div>

          <div class="clear"></div>

        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style>
  .member-tis .el-dialog{border-radius: 14px;margin-top: 26vh !important;;}
  .member-tis .el-dialog__header{padding: 0 !important;}
  .member-tis .el-dialog__body img{width: 100% !important;margin: 0 auto;}
  .member-tis .el-dialog__body {padding: 0;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import headfor from '@/components/public/headfor.vue';
import memberleft from '@/components/public/memberleft.vue'
import axios from 'axios'
export default{
  data(){
    return {
     activeIndex: '9',
     info:{},
     about:[],
     dialogVisible: false,
     fileList:[],
     datain:{
        uid:'',
        },
      loading:true,
      list: [],
      page:1,
      total:0,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Headfor': headfor,
    'Memberleft': memberleft,

  },
  mounted () {
      this.datain ={uid:this.$cookieStore.getCookie('userid')}
      this.recordapi();
  },
  methods:{
    xzadd(fileName){
      const fileUrl = fileName; // 文件的URL地址
      window.open("http://wfback.test1.dongbo.ren/"+fileUrl);
    },
    // upload:function(file) {
    //     console.log(file.target.files[0]);
    //     var forms = new FormData()
    //     var configs = {
    //         headers:{'Content-Type':'multipart/form-data;charse=UTF-8'},


    //     };
    //     forms.append('file',file.target.files[0]);
    //     // forms.append('aaa',123);
    //     console.log(forms);

    //     var that = this;

    //     axios.post('http://spoa/api.php/Upload/flie',forms)
    //       .then(function (response) {
    //         console.log(response)
    //           if (response.data.code == 0) {
    //               alert('文件上传成功');
    //           } else {
    //               alert('文件上传失败');
    //           }
    //           file.target.value = '';

    //       })
    //       .catch(function (error) {
    //           console.log(error);
    //       });
    // },



   handleUploadBefore (file) {

        const isLt2M = file.size / 1024 / 1024 < 5
        console.log(isLt2M);
        if (!isLt2M) {
          this.$message.warning('文件大小不能超过 5M')
        }
        return isLt2M
      },
      // 上传成功处理
      handleUploadSuccess (res) {
        console.log(res);
        // if (res.code === 200) {
        //   this.$message.success('导入成功')
        //   this.form.file = res.data
        //   this.getTableDataList()
        // } else {
        //   this.$message.error(res.msg)
        // }
      },

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        console.log(userid);
        that.$api.post("/index/sclist",{'userid':userid}).then(res => {
          console.log(res);
           if(res.code == 1){
             that.user= res.user;
             this.list = res.list.data;
             this.total = res.list.total
             this.info = res.info
             this.loading = false

           }

        });
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },



    handleClose(done) {

         done();
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Cglist.vue